import { Box, Button, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';
import { FunctionComponent, useContext } from 'react';

import { Context } from '../../../context';
import { DATA_HOOKS } from '../../../dataHooks';
import { isMobile } from '../../../utils/user-agent';
import { Breadcrumbs } from '../../Breadcrumbs';

import css from './index.module.scss';

export type NoResultsFoundProps = {
  term: string;
};

export const NoResultsFound: FunctionComponent<NoResultsFoundProps> = ({
  term,
}) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const context = useContext(Context);

  const breadcrumbItems = [
    { id: 'search-results', label: t('search-results-page.breadcrumb') },
  ];

  const emptyStateComp = (
    <Box
      className={css.NoResultsFound}
      direction="vertical"
      verticalAlign="middle"
      align="center"
      dataHook={DATA_HOOKS.SEARCH_RESULTS_NO_RESULTS_FOUND}
    >
      <Heading
        appearance="H2"
        dataHook={DATA_HOOKS.SEARCH_RESULTS_NO_RESULTS_FOUND_TITLE}
        className={css.title}
      >
        {t('search-results-page.no-results-found.title', { term })}
      </Heading>
      <Text
        weight="thin"
        size="medium"
        dataHook={DATA_HOOKS.SEARCH_RESULTS_NO_RESULTS_FOUND_DESCRIPTION}
        className={css.description}
      >
        {t('search-results-page.no-results-found.description')}
      </Text>
      <Button
        size={isMobile(context) ? 'small' : 'medium'}
        as="a"
        href={`/${locale}`}
        skin="standard"
        dataHook={DATA_HOOKS.SEARCH_RESULTS_NO_RESULTS_FOUND_CTA}
      >
        {t('search-results-page.no-results-found.return-to-homepage')}
      </Button>
    </Box>
  );

  return (
    <>
      <Breadcrumbs breadcrumbItems={breadcrumbItems} shallow={false} />
      {emptyStateComp}
    </>
  );
};
